import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  padding: 29px;
  background-color: #000000;
  color: #828282;
  text-align: center;
  margin-top:0.5px;
`;

const Footer = () => (
  <FooterWrapper>
    <p>© 2026 Aditi.All rights reserved.</p>
  </FooterWrapper>
);

export default Footer;

